<!--
 * @Author: wzh
 * @LastEditTime: 2023-05-31 09:44:23
 * @Description: 账号安全 第三方账户
-->
<template>
  <div>
    <List
      :pagination="false"
      addTitle=""
      ref="table"
      :loading="loading"
      :columns="columns"
      :isChecked="false"
      :dataSource="dataSource"
    >
      <!-- 状态 -->
      <template v-slot:userId="{ record }">
        <img src="@/assets/images/certife/success_icon.png" alt="" v-if="record.userId == 1" />
        <span v-else>{{ record.userId }}</span>
      </template>

      <!-- 操作按钮 -->
      <template v-slot:action="{ record }">
        <a-popconfirm :title="$t('home.account_third.unbind_tip')" @confirm="handleRemove(record)">
          <a>{{ $t("home.account_third.btn") }}</a>
        </a-popconfirm>
      </template>
    </List>
  </div>
</template>

<script>
import List from "@/components/public/list/ant";
import { commonAPI } from "@/apis";
import { mapGetters } from "vuex";

export default {
  name: "third",
  components: { List },
  data() {
    return {
      columns: [
        { title: this.$t("base.table.account"), dataIndex: "otherusername", align: "center" },
        { title: this.$t("home.account_third.columns.app_name"), dataIndex: "bindrappname", align: "center" },
        { title: this.$t("home.account_third.columns.bind_time"), dataIndex: "bindtime", align: "center" },
        {
          title: this.$t("base.table.action"),
          dataIndex: "action",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ],
      dataSource: [],
      loading: false,
    };
  },
  computed: {
    ...mapGetters("auth", ["user"]),
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取第三方绑定列表
    async getList() {
      this.loading = true;
      const { code, data, message } = await commonAPI.getAction(`/other/user/listByUserName/${this.user.username}`);
      this.loading = false;
      if (code == 0) {
        this.dataSource = data || [];
      } else {
        this.$message.error(message);
      }
    },
    // 解绑
    async handleRemove(record) {
      const { code, message } = await commonAPI.postAction(`/other/user/delete/${record.id}`);
      if (code == 0) {
        this.$message.success(this.$t("base.prompt.unbind_success_tip"));
        this.getList();
      } else {
        this.$message.error(message);
      }
    },
  },
};
</script>

<style></style>
